import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";

function ReportsMain() {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const checkEKOonboardStatus = () => {
    if (profiledetail.eko_onboard_status == "0") {
      return true;
    }
  };
  useEffect(() => {
    dispatch(setselectedTab("1211"));
  }, []);
  const ReportData = [
    ...(profiledetail.member_type_id === "4"
      ? [
          {
            key: "110.12",
            label: "Active/Deactive Services",
            route: "/active_deactive_services",
          },
        ]
      : []),
    {
      key: "11.3",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/aadharpay"}>
          <p>AEPS-Aadhar Pay</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.3"));
        dispatch(setHeadings("Aadhar Pay Report"));
      },
    },
    {
      key: "11.12",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/balance-enquirey"}>
          <p>AEPS-Balance Enquiry </p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.12"));
        dispatch(setHeadings("Balance Enquiry  Report"));
      },
    },
    {
      key: "11.1",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/cash-withdrawl"}>
          <p>AEPS-Cash Withdrawal </p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.1"));
        dispatch(setHeadings("Cash Withdrawal Report"));
      },
    },
    {
      key: "11.2",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/Mini-statement"}>
          <p> AEPS-Mini Statement</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.2"));
        dispatch(setHeadings("Mini Statement Report"));
      },
    },
    {
      key: "11.57",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/cash-transaction"}>
          <p>Aeps-2 Report</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.57"));
        dispatch(setHeadings("Credo Aeps Transaction"));
      },
    },
    {
      key: "110.4",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/bankVerify"}>
          <p>Bank Verify</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("110.4"));
      },
    },
    {
      key: "11.6",
      label: (
        <NavLink to={"/Report/bbps"}>
          <p>BBPS</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.6"));
        dispatch(setHeadings("BBPS Report"));
      },
    },
    {
      key: "110.5",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/eko/cms"}>
          <p>CMS</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("110.5"));
      },
    },
    {
      key: "110.8",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/eko/credit-card"}>
          <p>Credit Card</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("110.8"));
      },
    },
    ...(profiledetail.member_type_id !== "1" &&
    profiledetail.member_type_id !== "4"
      ? [
          {
            key: "110.9",
            label: "Commission Member Report",
            route: "/Report/commission_member",
          },
        ]
      : []),
    ...(profiledetail.member_type_id !== "1"
      ? [
          {
            key: "110.12",
            label: "Debit Credit Fund Report",
            route: "/debit_credit_fund",
          },
        ]
      : []),
    // {
    //   key: "11.7",
    //   label: (
    //     <NavLink to={"/Report/dmt"}>
    //       <p>Dmt</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("11.7"));
    //     dispatch(setHeadings("DMT Report"));
    //   },
    // },
    {
      key: "11.10",
      label: (
        <NavLink to={"/Report/fund-request"}>
          <p>Fund Request</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.10"));
        dispatch(setHeadings("Fund Request Report"));
      },
    },
    {
      key: "11.18",
      label: (
        <NavLink to={"/Report/loginHistory"}>
          <p>Login History</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.18"));
        dispatch(setHeadings("Login History Report"));
      },
    },
    {
      key: "11.13",
      label: (
        <NavLink to={"/Report/nsdl"}>
          <p>Nsdl</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.13"));
        dispatch(setHeadings("Nsdl Report"));
      },
    },
    // {
    //   key: "11.14",
    //   label: (
    //     <NavLink to={ "/Report/yesBank"}>
    //       <p>Yes Bank AEPS</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("11.14"));
    //     dispatch(setHeadings("Yes Bank AEPS"));
    //   },
    // },
    {
      key: "110.3",
      // icon: <MdAccountBalance />,
      label: (
        <NavLink to={"/Report/eko/pan"}>
          <p>Pan</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("110.3"));
      },
    },

    ...(profiledetail.member_type === "Retailer"
      ? [
          {
            key: "110.11",
            label: "Refund Transaction",
            route: "/Report/refundTransaction",
          },
        ]
      : []),
    {
      key: "11.5",
      label: (
        <NavLink to={"/Report/recharge"}>
          <p>Recharge</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.5"));
        dispatch(setHeadings("Recharge Report"));
      },
    },
    // {
    //   key: "11.4",
    //   label: (
    //     <NavLink to={"/Report/payout"}>
    //       <p>Payout</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("11.4"));
    //     dispatch(setHeadings("Payout Report"));
    //   },
    // },
    {
      key: "11.11",
      label: (
        <NavLink to={"/Report/xpressPayout"}>
          <p> Payments</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.11"));
      },
    },
    {
      key: "11.19",
      label: (
        <NavLink to={"/Report/upiPayments"}>
          <p>UPI Payments</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("11.19"));
      },
    },
    // {
    //   key: "11.16",
    //   label: (
    //     <NavLink to={"/Report/payfusion-xpressPayout"}>
    //       <p>PayFusion XpressPayout</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("11.16"));
    //   },
    // },

    // {
    //   key: "11.17",
    //   label: (
    //     <NavLink to={"/Report/m-atm"}>
    //       <p>M-ATM</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("11.17"));
    //     dispatch(setHeadings("M ATM Report"));
    //   },
    // },
    // {
    //   key: "11.8",
    //   label: (
    //     <NavLink to={"/Report/uti"}>
    //       <p>Uti</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("11.8"));
    //     dispatch(setHeadings("Uti Report"));
    //   },
    // },

    // {
    //   key: "11.15",
    //   label: (
    //     <NavLink to={"/Report/upi-dmt"}>
    //       <p>Upi DMT</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("11.15"));
    //     dispatch(setHeadings("Upi Dmt Report"));
    //   },
    // },
    // {
    //   key: "110.2",
    //   // icon: <MdAccountBalance />,
    //   label: (
    //     <NavLink to={"/Report/eko/aadhar"}>
    //       <Tooltip title="Aadhar">
    //         <p>Aadhar</p>
    //       </Tooltip>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("110.2"));
    //   },
    // },

    // profiledetail.member_type === "Retailer" && {
    //   key: "110.11",
    //   // icon: <MdAccountBalance />,
    //   label: (
    //     <NavLink to={"/Report/refundTransaction"}>
    //       <p>Refund Transaction</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("110.11"));
    //   },
    // },

    // {
    //   key: "110.6",
    //   // icon: <MdAccountBalance />,
    //   label: (
    //     <NavLink to={"/Report/eko/bbps"}>
    //       <Tooltip title="BBPS">
    //         <p>BBPS</p>
    //       </Tooltip>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("110.6"));
    //   },
    // },
    // {
    //   key: "110.7",
    //   // icon: <MdAccountBalance />,
    //   label: (
    //     <NavLink to={"/Report/eko/bbps-offline"}>
    //       <Tooltip title="BBPS Offline">
    //         <p>BBPS Offline</p>
    //       </Tooltip>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("110.7"));
    //   },
    // },
  ];

  return (
    <div className="m-4">
      {" "}
      <div className="  place-items-center gap-3">
        <div className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-2 bg-white h-18 text-center w-full rounded-xl cursor-pointer">
          <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
            Reports
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-4">
            {ReportData.map((i, id) => {
              if (
                i.key === "110.9" &&
                (profiledetail.member_type_id === "1" ||
                  profiledetail.member_type_id === "4")
              ) {
                return null;
              }

              return (
                <div
                  key={id}
                  className=" bg-primary rounded-xl cursor-pointer border-rgbaprimary9 border-t-2 text-center  justify-items-center"
                  onClick={() => {
                    // Navigate to the route defined in item.route
                    if (i.route) navigate(i.route);

                    // Optional: dispatch actions if needed
                    if (i.tabKey) dispatch(setselectedTab(i.tabKey));
                    if (i.heading) dispatch(setHeadings(i.heading));
                  }}
                >
                  <p className="text-white text-base font-bold p-2 hover:text-gray-300">
                    {i.label}
                  </p>
                </div>
              );
            })}{" "}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ReportsMain;
